<template>
  <div class="wrapper">
    <div class="item" @click="lookDetails('shangye')">
      <div class="img_con">
        <img src="https://ow-resource.gousii.com/image/solution/solution_rencai.png" alt="">
        <img class="fade_img" src="https://ow-resource.gousii.com/image/solution/solution_rencai2.png" alt="">
      </div>
      <label>商业和资产管理</label>
      <p>将商铺管理、运营管理、财务结算等核心业务拆解成标准化模块，实现跨平台、多终端智慧互联的数字化统管</p>
      <div class="btn_detail">了解详情</div>
    </div>
    <div class="item" @click="lookDetails('yuanqu')">
      <div class="img_con">
        <img src="https://ow-resource.gousii.com/image/solution/solution_shangye.png" alt="">
        <img class="fade_img" src="https://ow-resource.gousii.com/image/solution/solution_shangye2.png" alt="">
      </div>
      <label>智慧园区</label>
      <p>提供全面的跨平台数字化服务，助力园区实现智能化管理，提升运营效率，打造安全、便捷、高效的智慧园区新标杆</p>
      <div class="btn_detail">了解详情</div>
    </div>
    <div class="item" @click="lookDetails('gongyu')">
      <div class="img_con">
        <img src="https://ow-resource.gousii.com/image/solution/solution_dichan.png" alt="">
        <img class="fade_img" src="https://ow-resource.gousii.com/image/solution/solution_dichan2.png" alt="">
      </div>
      <label>智慧公寓</label>
      <p>依托跨平台技术，提供定制化服务，实现智能化管理、安全监控与高效运营，为公寓创造更便捷、舒适的居住新体验。</p>
      <div class="btn_detail">了解详情</div>
    </div>
    <div class="item" @click="lookDetails('lingshou')">
      <div class="img_con">
        <img src="https://ow-resource.gousii.com/image/solution/solution_xitong.png" alt="" width="72">
        <img class="fade_img" src="https://ow-resource.gousii.com/image/solution/solution_xitong2.png" alt=""
          width="72">
      </div>
      <label>智慧零售</label>
      <p>提供全方位数字化解决方案，助力零售商实现精准营销、高效管理和客户体验升级，开创智慧零售新篇章。</p>
      <div class="btn_detail">了解详情</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SolutionItem",
  methods: {
    lookDetails(name) {
      this.$router.push({ name: 'solutionDetails', params: { name: name } })
    }
  }
}
</script>

<style scoped lang="less">
.wrapper {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0px 0px 29px 0px rgba(213, 217, 222, .35);

  .item {
    width: 25%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 50px 45px;
    position: relative;
    cursor: pointer;
    transition: all .38s ease;

    .img_con {
      width: 70px;
      height: 70px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        position: absolute;
      }

      .fade_img {
        opacity: 0;
        transition: all .38s linear;
      }
    }

    label {
      font-size: 16px;
      font-weight: 600;
      color: #0B1D30;
      padding: 30px 0;
      cursor: pointer;
    }

    p {
      color: #42506c;
      font-size: 13px;
      text-align: left;
      height: 150px;
      margin: 0;
    }

    .btn_detail {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background-color: #016FFF;
      color: #fff;
      text-align: center;
      position: absolute;
      bottom: 0;
      left: 0;
      opacity: 0;
      transition: all .38s linear;
    }

    &:hover {
      box-shadow: 0px 7px 22px 10px rgba(0, 0, 0, 0.08);

      label {
        color: #0D2A42;
      }

      .btn_detail {
        opacity: 1;
      }

      .img_con {
        .fade_img {
          opacity: 1;
        }
      }
    }

    &+.item {
      border-left: solid 1px #F4F5FA;
    }
  }
}

@media screen and (max-width: 768px) {
  .wrapper {
    width: 100%;
    padding: 0 10px;

    .item {
      width: 50%;
      padding: 10px;
      border: 1px solid #EEEEEE;
    }
  }
}
</style>